import React, { useState, useEffect } from "react"
import _get from "lodash/get"
import { useSelector } from "react-redux"
import { getConfig } from "@/constants/config"
import { PARTS, PLUMBING_SERVICE_PARTS } from "@/constants"
import ProductTileView from "@/components/ProductList/v1/ProductTile"

const ProductTile = props => {
  const {
    data = {},
    presetConfigs = {},
    selectedtab = "",
    index = 0,
    hideCompare = false,
    staticTexts = {},
    swatchCount = 0,
    isFavoriteVariant = false,
    isVariantSku = {},
    brandSwitcherItems = [],
  } = props
  const compare = useSelector(state => state.compare)
  const [currencySign, setCurrencySign] = useState("")

  useEffect(() => {
    getConfig().then(config => {
      const currencySign = _get(config, "internationalization.currencySign", "")
      setCurrencySign(currencySign)
    })
  }, [])

  if (!data) return ""

  return (
    <div className="image-tile">
      <ProductTileView
        index={index}
        hideCompare={hideCompare}
        data={data}
        texts={staticTexts}
        addToCompare={() => {}}
        removeFromCompare={() => {}}
        compareData={compare}
        isEnable={false}
        currencySign={currencySign}
        favPage={true}
        swatchCount={swatchCount}
        presetConfigs={presetConfigs}
        selectedtab={selectedtab}
        type={
          data?.Brand_ss && data?.Brand_ss[0] === PLUMBING_SERVICE_PARTS
            ? PARTS
            : ""
        }
        isFavoriteVariant={isFavoriteVariant}
        isVariantSku={isVariantSku}
        brandSwitcherItems={brandSwitcherItems}
      />
    </div>
  )
}

export default ProductTile
